export class MascaraTelefoneCelular {
  aplicar(event: any) {
    const input = event.target;
    let rawValue = input.value.replace(/\D/g, '');

    rawValue = rawValue.substring(0, 11);
    let masked = '';
    if (rawValue.length > 0) {
      // DDD
      masked += '(' + rawValue.substring(0, 2);
      if (rawValue.length >= 3) {
        masked += ') ';
        // Decide se é fixo ou móvel
        if (rawValue.length <= 6) {
          masked += rawValue.substring(2);
        } else if (rawValue.length <= 10) {
          // formato fixo (8 dígitos)
          masked += rawValue.substring(2, 6) + '-' + rawValue.substring(6, 10);
        } else {
          // formato móvel (9 dígitos)
          masked += rawValue.substring(2, 7) + '-' + rawValue.substring(7);
        }
      }
    }
    masked = masked.replace(/\) $/, ')');
    input.value = masked;
    return {rawValue, masked};
  }
}
